import { ModalDialog } from '@fukuri-admins/ui/common';
import { TextInputFieldController } from '@fukuri-admins/ui/common/Form';
import styles from './styles.module.scss';

type Props = {
  onClose: () => void;
  onConfirm: () => void;
};

export const CreateClientAdminUserModalPresentation: React.FC<Props> = ({ onClose, onConfirm }) => {
  return (
    <ModalDialog
      isOpen
      title='企業管理者の新規追加'
      description='新規追加した管理者宛に、管理画面の案内メールが送信されます。'
      onClose={onClose}
      onConfirm={onConfirm}
      confirmText='追加'
      variant='md'
    >
      <div className={styles.formContainer}>
        <TextInputFieldController
          name='fullName'
          fieldWrapperProps={{
            labelText: '氏名',
          }}
          textInput={{
            placeholder: '福利 太郎',
          }}
        />
        <TextInputFieldController
          name='email'
          fieldWrapperProps={{
            labelText: 'メールアドレス',
          }}
          textInput={{
            type: 'email',
            placeholder: 'fukuri@example.com',
          }}
        />
      </div>
    </ModalDialog>
  );
};
